import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';

const LoginFooter = ({ loading = false }) => {
  const navigate = useNavigate();

  return (
    <div className="mt-8 text-center space-y-4">
      <div className="text-sm text-muted-foreground">
        Don't have an account?
      </div>
      
      <Button
        variant="outline"
        size="lg"
        fullWidth
        onClick={() => navigate('/register')}
        disabled={loading}
        iconName="UserPlus"
        iconPosition="left"
      >
        Create Account
      </Button>

      <div className="pt-4 border-t border-border">
        <p className="text-xs text-muted-foreground">
          By signing in, you agree to our Terms of Service and Privacy Policy
        </p>
      </div>
    </div>
  );
};

export default LoginFooter;